<template>
  <div class="min-h-screen quiz">
    <quiz-ui-title></quiz-ui-title>
    <quiz-ui-progress @select="onChangeIndex" :length="quizLength" :current="currentStepIndex"></quiz-ui-progress>
    <quiz-ui-question
      :type="type"
      :filter="filter"
      :current="currentStepIndex"
      :value=" branch && branch.value ? branch.value : null"
      @select="onBranchSelect"
      :question="quiz.branches"
      :category="category"
      @filters="onFilter"
      v-if="!currentStepIndex"
    ></quiz-ui-question>
    <quiz-ui-question
      :type="type"
      :filter="filter"
      :current="currentStepIndex"
      :key="currentStepIndex"
      @select="onSelect"
      :question="currentStep"
      :category="category"
      @filters="onFilter"
      v-if="currentStep"
    ></quiz-ui-question>
    <quiz-ui-final :typeproduct="type" @next="currentStepIndex++" :filter="filter" v-if="isFinal"></quiz-ui-final>
    <quiz-ui-success :typeproduct="type" :filter="filter" v-if="isSuccess"></quiz-ui-success>

    <div v-if="admin" class="filterString">{{ filter }}</div>
    <!-- <div v-if="admin" class="filterString">{{ this.$store.state.filtersQuiz }}</div> -->

  </div>
</template>

<script>
export default {
  props: {
    type: "mattress",
  },
  data() {
    return {
      quiz: window.__quiz__,
      currentStepIndex: 0,
      branch: null,
      values: {},
      filter: {},
      category: 0,
      arVariableSite: {},
      admin: this.$store.state.admin
    }
  },
  provide() {
    return {
      quiz: this.quiz,
      arVariableSite: this.arVariableSite,
      currentStepIndex: this.currentStepIndex,
      branch: this.branch,
    }
  },
  methods: {
    async onBranchSelect(option_event) {

      let iblock
      let _this = this
      var bodyFormData = new FormData();

      bodyFormData.append('data', JSON.stringify({'typeproduct': this.type, 'type': option_event.option.value}))

      await this.$axios({
        method: 'post',
        url: '/ajax/quiz/getSizes.php',
        data: bodyFormData,
      }).then(function (response) {
        let arr = []
        for (let i in response.data) {
          const data = { value: response.data[i] }
          arr.push(data)
        }
        //Добавляем размеры
        if(_this.type!="pillows"){
          switch (option_event.option.value) {
            case "Взрослый":
              _this.quiz.branches.options["0"].steps["0"].options["0"].options = arr;
              _this.category=0;
              break;
            case "Двое взрослых":
              _this.quiz.branches.options["1"].steps["0"].options["0"].options = arr;
              _this.category=1;
              break;
            case "Ребенок":
              _this.quiz.branches.options["2"].steps["0"].options["0"].options = arr;
              _this.category=2;
              break;
          }
          if (typeof (ym) === "function") {
            let yaCounterId = _this.$store.state.langs.YACOUNTER;
            ym(yaCounterId, 'reachGoal', 'quiz_people');
          }
        }

      })

      this.currentStepIndex = 1
      this.branch = option_event.option
      this.values[this.quiz.branches.question] = option_event.option.value
      this.filter[this.currentStepIndex] = {value: option_event.option.value, variants: option_event.option.variants, id: option_event.question.id, lab: option_event.question.question}
    },
    onSelect(event_select) {
      if(this.$store.state.admin){
        console.log( "event_select", event_select  );
        console.log( "this.$store.state", this.$store.state  );
      }

      const currentIdx = this.currentStepIndex
      this.values[this.currentStep.question] = event_select.option.value
      this.filter[currentIdx + 1] = {value: event_select.option.value, id: event_select.question.id, lab: event_select.question.question}
      this.currentStepIndex++
      if( this.type!="pillows" ) {
        switch (event_select.question.id) {
          case 2: //Уже знаете размер мартраса?
            if (typeof (ym) === "function") {
              let yaCounterId = this.$store.state.langs.YACOUNTER;
              ym(yaCounterId, 'reachGoal', 'quiz_size');
            }
            break;
          case 3: //Какой вес у спящего?
            if (typeof (ym) === "function") {
              let yaCounterId = this.$store.state.langs.YACOUNTER;
              ym(yaCounterId, 'reachGoal', 'quiz_wight');
            }
            break;
          case 4: //Какую жесткость матраса предпочитаете
            if (typeof (ym) === "function") {
              let yaCounterId = this.$store.state.langs.YACOUNTER;
              ym(yaCounterId, 'reachGoal', 'quiz_stiffness');
            }
            break;
          case 5:
            if (typeof (ym) === "function") {
              let yaCounterId = this.$store.state.langs.YACOUNTER;
              ym(yaCounterId, 'reachGoal', 'quiz_type');
            }
            break;
          case 6:
            if (typeof (ym) === "function") {
              let yaCounterId = this.$store.state.langs.YACOUNTER;
              ym(yaCounterId, 'reachGoal', 'quiz_price');
            }
            break;
          case 7:
            if (typeof (ym) === "function") {
              let yaCounterId = this.$store.state.langs.YACOUNTER;
              ym(yaCounterId, 'reachGoal', 'quiz_delivery');
            }
            break;
        }
      }

    },
    onChangeIndex(index) {
      this.currentStepIndex = index
    },
    onFilter(filter){
      this.filter = filter;
    }
  },
  created(){
    let arVariable = this.$store.state.langs.arVariableSite;
    let siteid = this.$store.state.langs.SITE_ID;
    this.arVariableSite = arVariable.find(v => v.SITE_ID_CITY === siteid);
  },
  computed: {
    isFinal() {
      return this.currentStepIndex === this.quizLength - 1
    },
    isSuccess() {
      return this.currentStepIndex === this.quizLength
    },
    firstBranch() {
      return this.quiz.branches.options[0]
    },
    steps() {
      return this.branch ? this.branch.steps : []
    },
    currentStep() {
      return this.steps[this.currentStepIndex - 1]
    },
    quizLength() {
      if (!this.branch) {
        return this.firstBranch.steps.length + 1
      } else {
        return this.branch.steps.length + 2
      }
    }
  },
  components: {
    'quiz-ui-header': () => import('./ui/quiz-ui-header.vue'),
    'quiz-ui-title': () => import('./ui/quiz-ui-title.vue'),
    'quiz-ui-progress': () => import('./ui/quiz-ui-progress.vue'),
    'quiz-ui-question': () => import('./ui/quiz-ui-question.vue'),
    'quiz-ui-footer': () => import('./ui/quiz-ui-footer.vue'),
    'quiz-ui-final': () => import('./ui/quiz-ui-final.vue'),
    'quiz-ui-success': () => import('./ui/quiz-ui-success.vue')
  }
}
</script>
